
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr/society/disaster-relief/covid-19",
      function () {
        return require("private-next-pages/csr/society/disaster-relief/covid-19.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csr/society/disaster-relief/covid-19"])
      });
    }
  